import { SidebarNoticeBox } from '@domain-group/suit-theme'

interface DataProviderBlankStateProps {
  title?: string,
}

const DataProviderBlankState = (props: DataProviderBlankStateProps) => {
  const { title } = props

  return (
    <SidebarNoticeBox>
      <SidebarNoticeBox.Title>
        {`${title ? `${title} ` : ''}Property Match Not Found`}
      </SidebarNoticeBox.Title>

      <SidebarNoticeBox.Paragraph>
        In order to search for similar features to your property, you&apos;ll need to match the property
        you&apos;re working on with {title || 'your data supplier'}&apos;s property identity code.
      </SidebarNoticeBox.Paragraph>

      <SidebarNoticeBox.Paragraph>
        If you have a {title || 'data supplier'} property id, you can
        manually set the property match below.
      </SidebarNoticeBox.Paragraph>
    </SidebarNoticeBox>
  )
}
export default DataProviderBlankState
